"use strict";

class SalesApplicationAddSalePDIController {

    constructor($scope, SSHttpService, SSUtilService, $timeout, SSEoiService, SSAwsService, SSAlertService, SSAppService) {
        const self = this;

        self.$scope = $scope;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.$timeout = $timeout;
        self.SSEoiService = SSEoiService;
        self.SSAwsService = SSAwsService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;        
        
        self.data = SHOWSUITE.data;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;

        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;

        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;
        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;        
        self.ASSET_MODEL_EOI_DOCUMENT = SHOWSUITE.ASSET_MODEL_EOI_DOCUMENT;
        self.ASSET_MODEL_EOI_INSTRUMENT = SHOWSUITE.ASSET_MODEL_EOI_INSTRUMENT;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;

        self.init();
    }

    init() {
        const self = this;

        self.allowEditBuyerDocuments = false;

        self.SSEoiService.pdiUploadDirty = false;
    }

    hideModals() {
        const self = this;

        self.showRemovePdiModal = false;

        if ($('#removePdiModal').is(':visible')) $('#removePdiModal').modal('hide');
    }

    addDocument() {
        const self = this;

        let new_document = {};

        if (!self.SSEoiService.sale_obj.pdi) {
            self.SSEoiService.sale_obj.pdi = [];
        }

        self.SSEoiService.sale_obj.pdi.push(new_document);

        self.$timeout(function() { 
            $(".dashboard-select[id^=format]").niceSelect('update');
        });
    }

    removeDocument(document) {
        const self = this;

        self.selected_document = document;

        self.hideModals();

        self.showRemovePdiModal = true;
        $('#removePdiModal').modal('show');
    }

    confirmRemoveDocument() {
        const self = this;

        if (self.selected_document.hasOwnProperty("id") && self.selected_document.id != null) {
            let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + self.selected_document.id + '/delete';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                
                self.removeDocumentObject(self.selected_document);
            });
        } else {
            self.removeDocumentObject(self.selected_document);
        }
    }

    removeDocumentObject(other_document) {
        const self = this;

        self.SSEoiService.sale_obj.pdi = self.SSEoiService.sale_obj.pdi.filter(item => item !== other_document);
        self.hideModals();
        self.SSAlertService.success('Success!', 'Other Document successfully removed.');
    }

    uploadOtherDocument(files, other_document, upload_type) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF file only');
            return;
        }

        let policyUrl = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {                
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            other_document['file_uri'] = response.config.data.key;
            other_document.file = file;
            self.SSEoiService.pdiUploadDirty = true;
        });
    }

    removeOtherDocument(documentObj, callback) {
        const self = this;

        if (documentObj.hasOwnProperty("id") && documentObj.id != null) {
            let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + documentObj.id + '/delete';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.SSAlertService.success('Success!', 'File deleted successfully.');

                documentObj.id = null;
                documentObj.file_uri = null;
                documentObj["show_file_url"] = null;
                documentObj.file = null;

                callback;
            });
        } else {
            //Haven't update EOI instruments
            documentObj.file_uri = null;
            documentObj["show_file_url"] = null;
            documentObj.file = null;
        }
    }

    replaceOtherDocument(files, upload_type, documentObj) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF file only');
            return;
        }

        let callback = self.uploadOtherDocument(files, documentObj, upload_type);

        self.removeOtherDocument(documentObj, callback);
    }

    proceedToDocumentUploadPage(self) {
        if (self.SSEoiService.buyers[0].type == SHOWSUITE.BUYER_TYPE_COMPANY) {
            self.SSEoiService.relationships = self.SSEoiService.corporate_relationships;
        } else {
            self.SSEoiService.relationships = self.SSEoiService.individual_relationships;
        }

        self.$timeout(function() { 
            //Prepare bank & relationship checking
            $.each(self.SSEoiService.sale_obj.instruments, function (index, instrument) {
                if (!self.SSEoiService.banks.find(x => x.name === instrument.bank_name)) {
                    instrument.bank_name_other = instrument.bank_name;
                    instrument.bank_name = "Others";
                }
                if (instrument.relationship_with_account_holder) {
                    instrument.relationshipCheck = true;
                    if (self.SSEoiService.relationships.find(x => x.name === instrument.relationship_with_account_holder)) {
                        instrument.relationship = instrument.relationship_with_account_holder;
                    } else {
                        instrument.relationship = "OTHERS";
                        instrument.relationship_other = instrument.relationship_with_account_holder;
                    }
                }
            })

            self.$timeout(function() { 
                $(".dashboard-select#relationship").niceSelect('update');
                $(".dashboard-select#documentUploadBank").niceSelect('update');
                $(".dashboard-select[id^=format]").niceSelect('update');
                $(".dashboard-select[id^=payment_type]").niceSelect('update');
            });
        });

        self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_DOCUMENT_UPLOAD_PAGE;
        self.SSAlertService.message = null
    }

    proceedToSummaryPage() {
        const self = this;

        self.uploadSaleOtherDocument(self.proceedToDocumentUploadPage);
    }

    uploadSaleOtherDocument(callback) {
        const self = this;

        let url = '';

        if (self.SSEoiService.sale_obj.pdi && self.SSEoiService.sale_obj.pdi.length > 0) {
            $.each(self.SSEoiService.sale_obj.pdi, function (index, other_document) {
                let params = {
                    name: other_document.name,
                    type: self.PROPERTY_DOCUMENT_TYPE_FORM,
                    format: SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF,
                    document_kind: other_document.document_kind,
                    file_uri: other_document.file_uri
                };

                loading(true);
                if (other_document.hasOwnProperty("id") && other_document.id != null) {
                    url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + other_document.id;

                    self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        if (!self.SSEoiService.sale_obj.hasOwnProperty("pdi")) {
                            self.SSEoiService.sale_obj["pdi"] = {};
                        }
                        other_document = response.data;

                        //Prepare preview image for documents
                        url = 'sec/assets/presigned-url';
                        params = {
                            'model': SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT,
                            'id': other_document.id
                        };
                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            loading(false);
                            if (response instanceof Error) {                            
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            other_document["show_file_url"] = response.data.presigned_url;
                            self.SSEoiService.sale_obj.pdi[index] = other_document;

                            if (index == self.SSEoiService.sale_obj.pdi.length - 1) {
                                callback(self);
                            }
                        });
                    });
                } else {
                    url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents'

                    self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        if (!self.SSEoiService.sale_obj.hasOwnProperty("pdi")) {
                            self.SSEoiService.sale_obj["pdi"] = {};
                        }
                        other_document = response.data.sale_document;

                        //Prepare preview image for documents
                        url = 'sec/assets/presigned-url';
                        params = {
                            'model': SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT,
                            'id': other_document.id
                        };
                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            loading(false);
                            if (response instanceof Error) {                            
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            other_document["show_file_url"] = response.data.presigned_url;
                            self.SSEoiService.sale_obj.pdi[index] = other_document;

                            if (index == self.SSEoiService.sale_obj.pdi.length - 1) {
                                callback(self);
                            }
                        });
                    });
                }
            });
        } else {
            callback(self);
        }
        
    }

}

SalesApplicationAddSalePDIController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', '$timeout', 'SSEoiService', 'SSAwsService', 'SSAlertService', 'SSAppService'];
app.controller('SalesApplicationAddSalePDIController', SalesApplicationAddSalePDIController);
